import { render, staticRenderFns } from "./LabelPreview.vue?vue&type=template&id=0b932a5b&scoped=true"
import script from "./LabelPreview.vue?vue&type=script&lang=js"
export * from "./LabelPreview.vue?vue&type=script&lang=js"
import style0 from "./LabelPreview.vue?vue&type=style&index=0&id=0b932a5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b932a5b",
  null
  
)

export default component.exports